export default __webpack_public_path__ + "images/CF.27b6cba.png";